import { useState } from 'react'
import { adminService } from 'core/services/adminService'

import c from './assets/sass/case-edit.module.scss'

export const CaseEdit = ({ caseData, onSave, onCancel }) => {
    const [form, setForm] = useState({
        name: caseData?.name || '',
        description: caseData?.description || '',
        price: caseData?.price || '',
        imageUrl: caseData?.imageUrl || '',
        isActive: caseData?.isActive ?? true,
        maxPromoCodes: caseData?.maxPromoCodes || '',
        dailyPurchaseLimit: caseData?.dailyPurchaseLimit || 5,
        category: 'STANDOFF_2',
    })
    const [promoCode, setPromoCode] = useState('')
    const [promoCodes, setPromoCodes] = useState('')
    const [promoGame, setPromoGame] = useState('STANDOFF_2')
    const [loading, setLoading] = useState(false)
    const [txtCodes, setTxtCodes] = useState([])
    const [showPromoCodes, setShowPromoCodes] = useState(false)
    const [promoCodesList, setPromoCodesList] = useState([])
    const [loadingPromoCodes, setLoadingPromoCodes] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            setLoading(true)
            const dataToSend = {
                ...form,
                maxPromoCodes: form.maxPromoCodes || null,
                dailyPurchaseLimit: form.dailyPurchaseLimit || 5,
            }
            if (caseData) {
                await adminService.updateCase(caseData.id, dataToSend)
            } else {
                await adminService.createCase(dataToSend)
            }
            onSave()
        } catch (error) {
            alert('Ошибка: ' + error.message)
        } finally {
            setLoading(false)
        }
    }

    const handleAddPromo = async () => {
        if (!promoCode.trim()) return
        try {
            await adminService.addPromoCode(caseData.id, promoCode, promoGame)
            setPromoCode('')
            alert('Промокод добавлен!')
            if (showPromoCodes) {
                loadPromoCodes()
            }
        } catch (error) {
            alert('Ошибка: ' + error.message)
        }
    }

    const handleAddPromosBulk = async () => {
        const codes = promoCodes
            .split('\n')
            .map((c) => c.trim())
            .filter(Boolean)
        if (codes.length === 0) return
        try {
            await adminService.addPromoCodesBulk(caseData.id, codes, promoGame)
            setPromoCodes('')
            alert(`Добавлено ${codes.length} промокодов!`)
            if (showPromoCodes) {
                loadPromoCodes()
            }
        } catch (error) {
            alert('Ошибка: ' + error.message)
        }
    }

    const handleTxtFileChange = (e) => {
        const file = e.target.files[0]
        if (!file) return

        const reader = new FileReader()
        reader.onload = (event) => {
            const text = event.target.result
            const codes = text
                .split('\n')
                .map((c) => c.trim())
                .filter(Boolean)
            setTxtCodes(codes)
        }
        reader.readAsText(file)
    }

    const handleAddFromTxt = async () => {
        if (txtCodes.length === 0) return
        try {
            await adminService.addPromoCodesBulk(caseData.id, txtCodes, promoGame)
            setTxtCodes([])
            alert(`Загружено ${txtCodes.length} промокодов из txt файла!`)
            if (showPromoCodes) {
                loadPromoCodes()
            }
        } catch (error) {
            alert('Ошибка: ' + error.message)
        }
    }

    const loadPromoCodes = async () => {
        if (!caseData) return
        try {
            setLoadingPromoCodes(true)
            const data = await adminService.getCasePromoCodes(caseData.id)
            setPromoCodesList(data.promoCodes || [])
        } catch (error) {
            console.error('Failed to load promo codes:', error)
        } finally {
            setLoadingPromoCodes(false)
        }
    }

    const togglePromoCodes = () => {
        if (!showPromoCodes && promoCodesList.length === 0) {
            loadPromoCodes()
        }
        setShowPromoCodes(!showPromoCodes)
    }

    return (
        <div className={c.component}>
            <h3>{caseData ? 'Редактирование кейса' : 'Создание кейса'}</h3>
            <form onSubmit={handleSubmit} className={c.form}>
                <label>
                    Название:
                    <input
                        type="text"
                        value={form.name || ''}
                        onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                        }
                        required
                    />
                </label>
                <label>
                    Описание:
                    <textarea
                        value={form.description || ''}
                        onChange={(e) =>
                            setForm({ ...form, description: e.target.value })
                        }
                        required
                    />
                </label>
                <label>
                    Цена:
                    <input
                        type="number"
                        value={form.price || ''}
                        onChange={(e) =>
                            setForm({ ...form, price: e.target.value || '0' })
                        }
                        required
                    />
                </label>
                <label>
                    URL картинки:
                    <input
                        type="text"
                        value={form.imageUrl || ''}
                        onChange={(e) =>
                            setForm({ ...form, imageUrl: e.target.value })
                        }
                    />
                </label>
                <div style={{ padding: '8px 12px', borderRadius: '6px', background: '#1a1a1a', fontSize: '12px', color: '#888', marginBottom: '4px' }}>
                    Универсальный кейс (Standoff 2 + PUBG Mobile)
                </div>
                <label>
                    Макс. промокодов (для отображения):
                    <input
                        type="number"
                        value={form.maxPromoCodes || ''}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                maxPromoCodes: e.target.value
                                    ? parseInt(e.target.value)
                                    : '',
                            })
                        }
                        placeholder="Оставьте пустым для авто"
                    />
                    <small style={{ color: '#999', fontSize: '12px' }}>
                        Если не указано - будет показывать реальное кол-во
                        промокодов
                    </small>
                </label>
                <label>
                    Лимит покупок в день (1 юзер):
                    <input
                        type="number"
                        value={form.dailyPurchaseLimit || 5}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                dailyPurchaseLimit:
                                    parseInt(e.target.value) || 5,
                            })
                        }
                        min="1"
                        required
                    />
                </label>
                <label className={c.checkbox}>
                    <input
                        type="checkbox"
                        checked={form.isActive}
                        onChange={(e) =>
                            setForm({ ...form, isActive: e.target.checked })
                        }
                    />
                    Активен
                </label>
                <div className={c.buttons}>
                    <button type="submit" disabled={loading}>
                        Сохранить
                    </button>
                    <button type="button" onClick={onCancel}>
                        Отмена
                    </button>
                </div>
            </form>

            {caseData && (
                <div className={c.promo}>
                    <h4>Игра для промокодов</h4>
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                        <button
                            type="button"
                            onClick={() => setPromoGame('STANDOFF_2')}
                            style={{
                                flex: 1, padding: '10px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: '13px',
                                background: promoGame === 'STANDOFF_2' ? '#EEAC2D' : '#2a2a2a',
                                color: promoGame === 'STANDOFF_2' ? '#000' : '#999'
                            }}
                        >
                            Standoff 2
                        </button>
                        <button
                            type="button"
                            onClick={() => setPromoGame('PUBG_MOBILE')}
                            style={{
                                flex: 1, padding: '10px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: '13px',
                                background: promoGame === 'PUBG_MOBILE' ? '#EEAC2D' : '#2a2a2a',
                                color: promoGame === 'PUBG_MOBILE' ? '#000' : '#999'
                            }}
                        >
                            PUBG Mobile
                        </button>
                    </div>
                    <div style={{ padding: '8px 12px', borderRadius: '6px', background: '#1a1a1a', marginBottom: '12px', fontSize: '12px', color: '#ccc' }}>
                        Вы добавляете промокоды для: <strong style={{ color: '#EEAC2D' }}>{promoGame === 'PUBG_MOBILE' ? 'PUBG Mobile' : 'Standoff 2'}</strong>
                    </div>
                    <h4>Добавить промокод</h4>
                    <div className={c.promoInput}>
                        <input
                            type="text"
                            value={promoCode || ''}
                            onChange={(e) => setPromoCode(e.target.value)}
                            placeholder="Промокод"
                        />
                        <button onClick={handleAddPromo}>Добавить</button>
                    </div>

                    <h4>Массовое добавление</h4>
                    <textarea
                        value={promoCodes || ''}
                        onChange={(e) => setPromoCodes(e.target.value)}
                        placeholder="Один промокод на строку"
                        rows={6}
                    />
                    <button onClick={handleAddPromosBulk}>Добавить все</button>

                    <h4>Загрузить из .txt файла</h4>
                    <div className={c.promoInput}>
                        <input
                            type="file"
                            accept=".txt"
                            onChange={handleTxtFileChange}
                        />
                        {txtCodes.length > 0 && (
                            <span>Загружено {txtCodes.length} промокодов</span>
                        )}
                    </div>
                    {txtCodes.length > 0 && (
                        <button onClick={handleAddFromTxt}>
                            Сохранить в базу
                        </button>
                    )}

                    <div className={c.promoList}>
                        <h4
                            onClick={togglePromoCodes}
                            style={{ cursor: 'pointer', userSelect: 'none' }}
                        >
                            {showPromoCodes ? '▼' : '▶'} Список промокодов (
                            {promoCodesList.length})
                        </h4>
                        {showPromoCodes && (
                            <div className={c.promoCodesContainer}>
                                {loadingPromoCodes ? (
                                    <div>Загрузка...</div>
                                ) : (
                                    <>
                                        <div className={c.promoStats}>
                                            <span>
                                                Выдано:{' '}
                                                {
                                                    promoCodesList.filter(
                                                        (p) => p.used
                                                    ).length
                                                }
                                            </span>
                                            <span>
                                                Осталось:{' '}
                                                {
                                                    promoCodesList.filter(
                                                        (p) => !p.used
                                                    ).length
                                                }
                                            </span>
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px', marginBottom: '8px', fontSize: '12px' }}>
                                            {(() => {
                                                const s2Total = promoCodesList.filter(p => p.game !== 'PUBG_MOBILE').length
                                                const s2Available = promoCodesList.filter(p => p.game !== 'PUBG_MOBILE' && !p.used).length
                                                const pubgTotal = promoCodesList.filter(p => p.game === 'PUBG_MOBILE').length
                                                const pubgAvailable = promoCodesList.filter(p => p.game === 'PUBG_MOBILE' && !p.used).length
                                                return (
                                                    <>
                                                        <span style={{ padding: '4px 8px', borderRadius: '4px', background: s2Available < 10 ? '#5c2020' : '#1a1a1a', color: s2Available < 10 ? '#ff6b6b' : '#ccc' }}>
                                                            SO2: {s2Available}/{s2Total}
                                                        </span>
                                                        <span style={{ padding: '4px 8px', borderRadius: '4px', background: pubgAvailable < 10 ? '#5c2020' : '#1a1a1a', color: pubgAvailable < 10 ? '#ff6b6b' : '#ccc' }}>
                                                            PUBG: {pubgAvailable}/{pubgTotal}
                                                        </span>
                                                    </>
                                                )
                                            })()}
                                        </div>
                                        <div className={c.promoCodesScroll}>
                                            {promoCodesList.map((promo) => (
                                                <div
                                                    key={promo.id}
                                                    className={c.promoCodeItem}
                                                    style={{
                                                        padding: '8px',
                                                        margin: '4px 0',
                                                        background: promo.used
                                                            ? '#2a2a2a'
                                                            : '#1a1a1a',
                                                        borderRadius: '4px',
                                                        fontSize: '13px',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent:
                                                                'space-between',
                                                            alignItems:
                                                                'center',
                                                        }}
                                                    >
                                                        <code
                                                            style={{
                                                                color: promo.used
                                                                    ? '#666'
                                                                    : '#fff',
                                                            }}
                                                        >
                                                            {promo.code}
                                                        </code>
                                                        <span style={{ color: '#EEAC2D', fontSize: '10px', marginLeft: '6px' }}>
                                                            {promo.game === 'PUBG_MOBILE' ? 'PUBG' : 'SO2'}
                                                        </span>
                                                        {promo.used && (
                                                            <span
                                                                style={{
                                                                    color: '#888',
                                                                    fontSize:
                                                                        '11px',
                                                                }}
                                                            >
                                                                Выдан:{' '}
                                                                {promo.usedBy
                                                                    ?.username ||
                                                                    promo.usedBy
                                                                        ?.siteId ||
                                                                    'Unknown'}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}
